// Estilos dos pontos de arrasto usados para curvar a conexão entre equipamentos
const styles = (theme) => ({
  bendHandle: {
    position: "absolute",
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.primary.main}`,
    pointerEvents: "all",
  },
  // Faixa invisível sobre cada trecho da linha: clicar nela insere um novo ponto de curvatura ali
  segmentHitArea: {
    fill: "none",
    stroke: "transparent",
    strokeWidth: 16,
    cursor: "copy",
    pointerEvents: "stroke",
  },
});

export default styles;
